import { Card, CardHeader, CardTitle } from '@/components'
import { DataTableV3 } from '@/components/ui-plus/data-table-v3'

import { Item } from '../entities/item'

function formatBRL(value: number) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
    .format(value)
    .replace(/R\$*\D/, '') // Remove o R$ e o espaço
}

export function ItensCard({ itens }: { itens: Item[] }) {
  const total = itens.reduce((acc, item) => acc + item.valorTotal, 0)

  return (
    <Card>
      <CardHeader>
        <CardTitle>Itens da ordem</CardTitle>
      </CardHeader>

      <DataTableV3
        data={itens}
        columns={[
          {
            accessorKey: 'sku',
            header: 'Nome',
            cell: ({ row: { original } }) => (
              <div>
                <div className="text-xs font-bold">{original.sku}</div>
                <div>{original.nome}</div>
              </div>
            ),
            footer: 'Total',
          },
          {
            accessorKey: 'qtd',
            header: () => <div className="w-full text-right">Qtd.</div>,
            cell: ({ row: { original } }) => (
              <div className="w-full text-right">{original.qtd}</div>
            ),
          },
          {
            accessorKey: 'valorUnit',
            header: () => <div className="w-full text-right">R$ Unit.</div>,
            cell: ({ row: { original } }) => (
              <div className="w-full text-right">
                {formatBRL(original.valorUnit)}
              </div>
            ),
          },
          {
            accessorKey: 'valorTotal',
            header: () => <div className="w-full text-right">R$. Total</div>,
            cell: ({ row: { original } }) => (
              <div className="w-full text-right">
                {formatBRL(original.valorTotal)}
              </div>
            ),
            footer: () => (
              <div className="w-full text-right font-bold">
                {formatBRL(total)}
              </div>
            ),
          },
        ]}
      />
    </Card>
  )
}
